var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Treeselect',{attrs:{"placeholder":"Selecione um item da esturtura organizacional...","options":_vm.options},model:{value:(_vm.organizational_structure_id),callback:function ($$v) {_vm.organizational_structure_id=$$v},expression:"organizational_structure_id"}})
}
var staticRenderFns = []

export { render, staticRenderFns }